import { scene } from '../../theme';

// ---------------------------------------------------------------------------
// Stage — `theme.ts` lighting + ground plane. The lighting block is a
// near-copy of GameShell's so the viewer looks like the game.
//
// Promoted from client/src/tools/assets/presets.tsx (the asset viewer's
// inline copy) so the trees viewer can reuse it without copy-paste. Per
// in_game_tooling.md's "share upward when a second case appears" rule.
// ---------------------------------------------------------------------------

export function StageScene() {
  return (
    <>
      <fog attach="fog" args={[scene.fog, scene.fogNear, scene.fogFar]} />
      <ambientLight color={scene.ambientColor} intensity={scene.ambientIntensity} />
      <directionalLight
        color={scene.directionalColor}
        position={[8, 12, 6]}
        intensity={scene.directionalIntensity}
        castShadow
        shadow-mapSize-width={1024}
        shadow-mapSize-height={1024}
        shadow-camera-near={1}
        shadow-camera-far={30}
        shadow-camera-left={-10}
        shadow-camera-right={10}
        shadow-camera-top={10}
        shadow-camera-bottom={-10}
      />
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -0.001, 0]} receiveShadow>
        <planeGeometry args={[20, 20]} />
        <meshStandardMaterial color={scene.ground} />
      </mesh>
    </>
  );
}

// ---------------------------------------------------------------------------
// Neutral — flat lighting, no fog, no ground. The "is the mesh / material
// itself ok" preset, decoupled from in-game lighting.
// ---------------------------------------------------------------------------

export function NeutralScene() {
  return (
    <>
      <ambientLight color="#ffffff" intensity={0.6} />
      <directionalLight color="#ffffff" position={[5, 8, 5]} intensity={0.8} />
      <directionalLight color="#ffffff" position={[-5, 4, -3]} intensity={0.3} />
    </>
  );
}

// ---------------------------------------------------------------------------
// ViewportGrid — independent of preset. 20×20m, 1m squares with every 5th
// line emphasized via a coarser overlay grid. Renders slightly above ground
// (y=0.0005) on Stage so it doesn't z-fight with the ground plane; on
// Neutral it sits at y=0.
// ---------------------------------------------------------------------------

export function ViewportGrid() {
  return (
    <>
      <gridHelper args={[20, 20, '#3d3d3d', '#272727']} position={[0, 0.001, 0]} />
      <gridHelper args={[20, 4, '#5a5a5a', '#272727']} position={[0, 0.0015, 0]} />
    </>
  );
}
